export const useStyles = () => {
  return {
    filterContainer: {
        width: '100%',
      '& .filterContainer': {
        width: { lg: 'fit-content', md: '100%', sm: '100%' },
      },
    },
  }
}
